import React from 'react';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

/* 1セルの高さ定義 */
const itemHeight = 60;

const timeLineItems = {
  width: '20%'
};

const timeLineTitle = {
  width: '100%', // サイズ合わせ
  height: '100px',
  borderBottom: 'solid 1px #ccc',
  margin: 0,
  padding: 0,
  backgroundColor: '#FFFFFF',
  zIndex: 998,
  position: 'fixed'
};

const timeLineItem = {
  width: '100%',
  height: `${itemHeight}px`,
  borderRight: 'solid 1px #ccc',
  borderBottom: 'solid 1px #ccc',
  margin: 0,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '20px'
};

type Props = {
  startTime: string;
  endTime: string;
};

dayjs.extend(customParseFormat);
const ScheduleTimeLine = (props: Props) => {
  const { startTime, endTime } = props;

  // 開始から終了時刻までを30分刻みで配列化する
  const initTimeLine = () => {
    const result: string[] = [];

    let currentTime = dayjs(startTime, 'HH:mm');
    const finishTime = dayjs(endTime, 'HH:mm');

    while (currentTime <= finishTime) {
      result.push(currentTime.format('HH:mm'));
      // TODO 施設ごとに可変対応
      // currentTime = currentTime.add(30, 'minute');
      currentTime = currentTime.add(60, 'minute');
    }

    return result;
  };

  const timeLines = initTimeLine();

  return (
    <div style={timeLineItems}>
      {/* タイトル部分で空白を設定 */}
      <div
        style={{
          ...timeLineTitle,
          position: 'fixed'
        }}
      />
      {/* 明細部分 */}
      <div style={{ marginTop: '100px' }}>
        {timeLines.map((value) => (
          <li style={timeLineItem} key={value.toString()}>
            {value}
          </li>
        ))}
      </div>
    </div>
  );
};
export default ScheduleTimeLine;
